import { useCallback, useState } from "react"

export function useChatMessages(initialChatMessages = []) {
  const [chatMessages, setChatMessages] = useState(initialChatMessages)

  const appendMessagesToChat = useCallback(
    (...messages) => setChatMessages((_chatMessages) => [..._chatMessages, ...messages]),
    []
  )

  const resetChatMessages = useCallback((messagesAfterReset = []) => {
    setChatMessages(messagesAfterReset)
  }, [])

  return { chatMessages, appendMessagesToChat, resetChatMessages }
}
